export type GuideCategory = 'Getting started' | 'Converter' | 'PDF tools' | 'Text editor' | 'Typing' | 'File formats';

export const GUIDE_CATEGORIES: GuideCategory[] = ['Getting started', 'Converter', 'PDF tools', 'Text editor', 'Typing', 'File formats'];

export interface Guide {
  slug: string;
  title: string;
  description: string; // meta description, ~150-160 chars
  publishedDate: string; // ISO date
  affiliateCategory?: string;
  category: GuideCategory;
  body: string; // markdown
}
